// @ts-nocheck
import React, { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import history from '@/asset/js/history';
import Loading from '@/component/loading';
import { isMyBoboup } from '@/asset/js/utils';

const AboutBadges = lazy(() => import(/* webpackChunkName: "aboutBadges" */'@/page/aboutBadges'));
// const Home = lazy(() => import('@/page/home'));
const Main = lazy(() => import('@/page/main'));
// const PrivacyPolicy = lazy(() => import('@/page/privacyPolicy'));
const PrivacyPolicyBobo = lazy(() => import('@/page/privacyPolicyBobo'));
// const TermsAndConditions = lazy(() => import('@/page/terms&Conditions'));
const TermsAndConditionsBobo = lazy(() => import('@/page/terms&ConditionsBobo'));
const Concat = lazy(() => import('@/page/concat'));
const About = lazy(() => import(/* webpackChunkName: "about" */ '@/page/about'));
const Report = lazy(() => import(/* webpackChunkName: "report" */ '@/page/report'));
const Feedback = lazy(() => import(/* webpackChunkName: "feedback" */ '@/page/feedback'));
const GoldCoin = lazy(() => import(/* webpackChunkName: "goldCoin" */'@/page/goldCoin'));
const RankingList = lazy(() => import(/* webpackChunkName: "rankingList" */'@/page/rankingList'));
const CoinMerchant = lazy(() => import(/* webpackChunkName: "coinMerchant" */'@/page/coinMerchant'));
const Level = lazy(() => import(/* webpackChunkName: "level" */'@/page/level'));
const NewFamilyExp = lazy(() => import(/* webpackChunkName: "newFamilyExp" */'@/page/newFamilyExp'));
const FamilyTask = lazy(() => import(/* webpackChunkName: "familyTask" */'@/page/familyTask'));
const LuckyGiftList = lazy(() => import(/* webpackChunkName: "luckyGiftList" */'@/page/luckyGiftList'));
const FamilyRankList = lazy(() => import(/* webpackChunkName: "familyRankList" */'@/page/familyRankList'));
const LuckyPacketHelp = lazy(() => import(/* webpackChunkName: "luckyPacketHelp" */'@/page/luckyPacketHelp'));
const VipRules = lazy(() => import(/* webpackChunkName: "vipRules" */'@/page/vipRules'));
const Recharge = lazy(() => import(/* webpackChunkName: "recharge" */'@/page/recharge'));
const RechargeResult = lazy(() => import(/* webpackChunkName: "rechargeResult" */'@/page/rechargeResult'));
const SVipRules = lazy(() => import(/* webpackChunkName: "sVipRules" */'@/page/sVipRules'));
const TotalRankVoice = lazy(() => import(/* webpackChunkName: "totalRank" */'@/page/totalRank'));
const NobleRules = lazy(() => import(/* webpackChunkName: "nobleRules" */'@/page/nobleRules'));
const DiamondsFlow = lazy(() => import(/* webpackChunkName: "diamondsFlow" */'@/page/diamondsFlow'));
const NewTask = lazy(() => import(/* webpackChunkName: "newTask" */'@/page/newTask'));
const GiftList = lazy(() => import(/* webpackChunkName: "giftList" */'@/page/giftList'));
const CpList = lazy(() => import(/* webpackChunkName: "cpList" */'@/page/cpList'));
const DreamCityNew = lazy(() => import(/* webpackChunkName: "dreamCityNew" */'@/page/dreamCityNew'));
const RechargeEvent = lazy(() => import(/* webpackChunkName: "rechargeEvent" */'@/page/rechargeEvent'));
const LuckyDraw = lazy(() => import(/* webpackChunkName: "luckyDraw" */'@/page/luckyDraw'));
const RechargeLucky = lazy(() => import(/* webpackChunkName: "rechargeLucky" */'@/page/rechargeLucky'));
const CoinsBattle = lazy(() => import(/* webpackChunkName: "coinsBattle" */'@/page/coinsBattle'));
const LuckyDrawMay = lazy(() => import(/* webpackChunkName: "luckyDrawMay" */'@/page/luckyDrawMay'));
const FestivalOfSacrifice = lazy(() => import(/* webpackChunkName: "festivalOfSacrifice" */'@/page/festivalOfSacrifice'));
// const JungleExpedition = lazy(() => import(/* webpackChunkName: "jungleExpedition" */'@/page/jungleExpedition'));
const JungleExpeditionV2 = lazy(() => import(/* webpackChunkName: "jungleExpeditionV2" */'@/page/jungleExpeditionV2'));
const GameKing = lazy(() => import(/* webpackChunkName: "gameKing" */'@/page/gameKing'));
const CrazyBuilder = lazy(() => import(/* webpackChunkName: "crazyBuilder" */'@/page/crazyBuilder'));
const SpeedPassion = lazy(() => import(/* webpackChunkName: "speedPassion" */'@/page/speedPassion'));
const HungryGhost = lazy(() => import(/* webpackChunkName: "hungryGhost" */'@/page/hungryGhost'));
const FishingActivity = lazy(() => import(/* webpackChunkName: "fishingActivity" */'@/page/fishingActivity'));
const AnniversaryCelebration2 = lazy(() => import(/* webpackChunkName: "anniversaryCelebration2" */'@/page/anniversaryCelebration2'));
const SpringFestivalCP = lazy(() => import(/* webpackChunkName: "springFestivalCP" */'@/page/springFestivalCP'));
const GameList = lazy(() => import(/* webpackChunkName: "gameList" */'@/page/gameList'));
const RamadanNew = lazy(() => import(/* webpackChunkName: "ramadanNew" */'@/page/ramadanNew'));
const LasserBairam = lazy(() => import(/* webpackChunkName: "lasserBairam" */'@/page/lasserBairam'));
const AchorRank = lazy(() => import(/* webpackChunkName: "achorRank" */'@/page/achorRank'));
const AnnualRanking = lazy(() => import(/* webpackChunkName: "annualRanking" */'@/page/annualRanking'));
const BiuBiuBuilding = lazy(() => import(/* webpackChunkName: "biuBiuBuilding" */'@/page/biuBiuBuilding'));
const LuckyRankVs = lazy(() => import(/* webpackChunkName: "luckyRankVs" */'@/page/luckyRankVs'));
const AnchorPK = lazy(() => import(/* webpackChunkName: "anchorPK" */'@/page/anchorPK'));
const GameCenterList = lazy(() => import(/* webpackChunkName: "gameCenterList" */'@/page/gameCenterList'));
const OfficialRule = lazy(() => import(/* webpackChunkName: "officialRule" */'@/page/officialRule'));
const Airwallex = lazy(() => import(/* webpackChunkName: "airwallex" */'@/page/airwallex'));
const Mpesa = lazy(() => import(/* webpackChunkName: "mpesa" */'@/page/mpesa'));
const ChatSkill = lazy(() => import(/* webpackChunkName: "chatSkill" */'@/page/chatSkill'));
const ImageLink = lazy(() => import(/* webpackChunkName: "imageLink" */'@/page/imageLink'));
const Airtel = lazy(() => import(/* webpackChunkName: "airtel" */'@/page/airtel'));
const ReceiveList = lazy(() => import(/* webpackChunkName: "receiveList" */'@/page/receiveList'));
const Withdraw = lazy(() => import(/* webpackChunkName: "withdraw" */'@/page/withdraw'));
const WithdrawBind = lazy(() => import(/* webpackChunkName: "withdrawBind" */'@/page/withdrawBind'));
const GiftWall = lazy(() => import(/* webpackChunkName: "giftWall" */'@/page/giftWall'));
const NewAristocracy = lazy(() => import(/* webpackChunkName: "curAristocracy" */'@/page/curAristocracy'));
const VipPrivileges = lazy(() => import(/* webpackChunkName: "vipPrivileges" */'@/page/vipPrivileges'));
const VipHelp = lazy(() => import(/* webpackChunkName: "vipHelp" */'@/page/vipHelp'));
const MyEarning = lazy(() => import(/* webpackChunkName: "myEarning" */'@/page/myEarning'));
const Share = lazy(() => import(/* webpackChunkName: "share" */'@/page/share'));
const TotalRank = lazy(() => import(/* webpackChunkName: "totalRankAll" */'@/page/totalRankAll'));
const CommunityRules = lazy(() => import(/* webpackChunkName: "communityRules" */'@/page/communityRules'));
const NewcomerGuide = lazy(() => import(/* webpackChunkName: "newcomerGuide" */'@/page/newcomerGuide'));
const TvWallRule = lazy(() => import(/* webpackChunkName: "tvWallRule" */'@/page/tvWallRule'));
const TiktokLogin = lazy(() => import(/* webpackChunkName: "tiktokLogin" */'@/page/tiktokLogin'));
const NewUserRewards = lazy(() => import(/* webpackChunkName: "newUserRewards" */'@/page/newUserRewards'));
const ChildrenPolicy = lazy(() => import(/* webpackChunkName: "childrenPolicy" */'@/page/childrenPolicy'));
const ProgramList = lazy(() => import(/* webpackChunkName: "programList" */'@/page/programList'));
const Convention = lazy(() => import(/* webpackChunkName: "convention" */'@/page/convention'));
const AccountIllustrate = lazy(() => import(/* webpackChunkName: "accountIllustrate" */'@/page/accountIllustrate'));
const Help = lazy(() => import(/* webpackChunkName: "help" */'@/page/help'));
const IncomeRules = lazy(() => import(/* webpackChunkName: "incomeRules" */'@/page/incomeRules'));
const RetirarRules = lazy(() => import(/* webpackChunkName: "retirarRules" */'@/page/retirarRules'));
const SpecialRecharge = lazy(() => import(/* webpackChunkName: "specialRecharge" */'@/page/specialRecharge'));

const authcheck = Com => {
  return (
    // <ErrorBoundary>
    <Suspense fallback={<Loading />}>
      <Com history={history} />
    </Suspense>
    // </ErrorBoundary>
  );
};

const suspense = (Com, params) => {
  return (
    <Suspense fallback={<Loading />}>
      <Com {...params} />
    </Suspense>
  );
};

const boboupList = [
  {
    path: '/',
    element: <Navigate to='/main' />
  },
  {
    path: '/main',
    element: suspense(Main)
  },
  {
    path: '/about_badges',
    element: suspense(AboutBadges)
  },
  // {
  //   path: '/home',
  //   element: suspense(Home),
  // },
  {
    path: '/user/privPolicy',
    element: suspense(PrivacyPolicyBobo)
  },
  {
    path: '/user/termService',
    element: suspense(TermsAndConditionsBobo)
  },
  {
    path: '/coin_flow',
    element: authcheck(GoldCoin),
  },
  {
    path: '/gold_coin',
    element: authcheck(GoldCoin),
  },
  // {
  //   path: '/app/AppInfo',
  //   element: suspense(About),
  // },
  {
    path: '/report/room',
    element: suspense(Report, { type: 'room' })
  },
  {
    path: '/report/user',
    element: suspense(Report, { type: 'user' })
  },
  {
    path: '/report/family',
    element: suspense(Report, { type: 'family' })
  },
  {
    path: '/feedback/user',
    element: suspense(Feedback)
  },
  // {
  //   path: '/gift_ranking_list',
  //   element: authcheck(RankingList),
  // },
  // {
  //   path: '/user/servicePolicy',
  //   element: suspense(TermsAndConditions)
  // },
  {
    path: '/user/concat',
    element: suspense(Concat)
  },
  {
    path: '/mine_level',
    element: authcheck(Level),
  },
  {
    path: '/level',
    element: authcheck(Level),
  },
  {
    path: '/coins_trader/*',
    element: suspense(CoinMerchant),
  },
  {
    path: '/family_task',
    element: suspense(FamilyTask),
  },
  {
    path: '/new_family_exp',
    element: suspense(NewFamilyExp),
  },
  {
    path: '/fortunate_present_rank/*',
    element: suspense(LuckyGiftList),
  },
  {
    path: '/family_rank_list/*',
    element: suspense(FamilyRankList),
  },
  {
    path: '/lucky_packet_help',
    element: suspense(LuckyPacketHelp),
  },
  {
    path: '/vip_regulation',
    element: authcheck(VipRules),
  },
  {
    path: '/svip_regulation',
    element: authcheck(SVipRules),
  },
  {
    path: '/recharge/*',
    element: authcheck(Recharge),
  },
  {
    path: '/recharge_result',
    element: authcheck(RechargeResult),
  },
  {
    path: '/noble_rules',
    element: authcheck(NobleRules),
  },
  {
    path: '/voice_rank/*',
    element: suspense(TotalRankVoice),
  },
  {
    path: '/mine_received_records/*',
    element: authcheck(DiamondsFlow),
  },
  {
    path: '/diamonds_flow/*',
    element: authcheck(DiamondsFlow),
  },
  {
    path: '/mine_task',
    element: suspense(NewTask),
  },
  {
    path: '/task_center',
    element: authcheck(NewTask),
  },
  {
    path: '/gift_list',
    element: authcheck(GiftList),
  },
  {
    path: '/cp_list',
    element: authcheck(CpList),
  },
  {
    path: '/dreac_city_new',
    element: authcheck(DreamCityNew),
  },
  {
    path: '/recharge_event/*',
    element: suspense(RechargeEvent),
  },
  {
    path: '/lucky_draw/*',
    element: suspense(LuckyDraw),
  },
  {
    path: '/recharge_lucky/*',
    element: suspense(RechargeLucky),
  },
  {
    path: '/lucky_rank_vs/*',
    element: suspense(LuckyRankVs),
  },
  {
    path: '/anchor_pk',
    element: authcheck(AnchorPK),
  },
  {
    path: '/biu_biu_building/*',
    element: suspense(BiuBiuBuilding),
  },
  {
    path: '/annual_ranking/*',
    element: suspense(AnnualRanking),
  },
  {
    path: '/achor_rank',
    element: authcheck(AchorRank),
  },
  {
    path: '/spring_festival_cp',
    element: authcheck(SpringFestivalCP),
  },
  {
    path: '/game_list',
    element: authcheck(GameList),
  },
  {
    path: '/ramadan_new',
    element: authcheck(RamadanNew),
  },
  {
    path: '/lasser_bairam',
    element: authcheck(LasserBairam),
  },
  {
    path: '/coins_battle',
    element: authcheck(CoinsBattle),
  },
  {
    path: '/lucky_draw_may',
    element: authcheck(LuckyDrawMay),
  },
  {
    path: '/festival_of_sacrifice/*',
    element: authcheck(FestivalOfSacrifice),
  },
  {
    path: '/game_king',
    element: authcheck(GameKing),
  },
  {
    path: '/jungle_expedition',
    element: authcheck(JungleExpeditionV2),
  },
  {
    path: '/crazy_builder/*',
    element: authcheck(CrazyBuilder),
  },
  {
    path: '/speed_passion',
    element: authcheck(SpeedPassion),
  },
  {
    path: '/hungry_ghost',
    element: authcheck(HungryGhost),
  },
  {
    path: '/fishing_activity',
    element: authcheck(FishingActivity),
  },
  {
    path: '/anniversary_celebration_2',
    element: authcheck(AnniversaryCelebration2),
  },
  {
    path: '/game_center_list',
    element: authcheck(GameCenterList),
  },
  {
    path: '/official_rules',
    element: authcheck(OfficialRule),
  },
  {
    path: '/airwallex',
    element: suspense(Airwallex),
  },
  {
    path: '/mpesa/*',
    element: suspense(Mpesa),
  },
  {
    path: '/airtel/*',
    element: suspense(Airtel),
  },
  {
    path: '/chat_skill',
    element: suspense(ChatSkill),
  },
  {
    path: '/image_link',
    element: authcheck(ImageLink),
  },
  {
    path: '/gift_ranking_list',
    element: authcheck(ReceiveList),
  },
  {
    path: '/withdraw/*',
    element: suspense(Withdraw),
  },
  {
    path: '/withdraw_bind',
    element: authcheck(WithdrawBind),
  },
  {
    path: '/home_giftWall/*',
    element: authcheck(GiftWall),
  },
  {
    path: '/new_aristocracy',
    element: suspense(NewAristocracy),
  },
  {
    path: '/vip_privileges',
    element: authcheck(VipPrivileges),
  },
  {
    path: '/vip_help',
    element: authcheck(VipHelp),
  },
  {
    path: '/mine_received',
    element: authcheck(MyEarning),
  },
  {
    path: '/room_share',
    element: authcheck(Share),
  },
  {
    path: '/home_rank_all/*',
    element: suspense(TotalRank),
  },
  {
    path: '/community_norms',
    element: suspense(CommunityRules),
  },
  {
    path: '/newcomer_guide',
    element: authcheck(NewcomerGuide),
  },
  {
    path: '/tv_wall_rules',
    element: suspense(TvWallRule),
  },
  {
    path: '/tiktok_login',
    element: authcheck(TiktokLogin),
  },
  {
    path: '/new_user_rewards',
    element: suspense(NewUserRewards),
  },
  {
    path: '/child_policy',
    element: suspense(ChildrenPolicy),
  },
  {
    path: '/program_list',
    element: suspense(ProgramList),
  },
  {
    path: '/community_convention',
    element: suspense(Convention),
  },
  {
    path: '/account_illustrate',
    element: suspense(AccountIllustrate),
  },
  {
    path: '/help/*',
    element: suspense(Help),
  },
  {
    path: '/income_rules',
    element: suspense(IncomeRules),
  },
  {
    path: '/retirar_rules',
    element: suspense(RetirarRules),
  },
  {
    path: '/special_recharge',
    element: suspense(SpecialRecharge),
  },
];
// export default boboupList;

export default boboupList;
